<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div fxLayout="column" id="itemRecordContainer">
  <record-text [text]="record.questionText"></record-text>
  <div
    fxLayout="row"
    *ngFor="let answer of record.answers; let i = index"
    id="recordCheckboxesContainer"
  >
    <record-icon-text
      [text]="getText(answer, i)"
      [componentColor]="answer.isTriggered ? '#B00020' : '#5C5C5B'"
      [icon]="answer.isSelected ? faCheckSquare : faSquare"
    ></record-icon-text>
  </div>
  <div *ngIf="record.image" id="recordImageContainer">
    <record-image [images]="[record.image]"></record-image>
  </div>
</div>
